import { DialogTag } from '@pixelgenau/ngx-dialog';

export const MainNavDialogTag = new DialogTag('nav-dialog', () => import('./main-nav.component'));
